
export const STATUS_ACTIVE = 'active' as const
export const STATUS_WITHDRAWN = 'withdrawn' as const // изъят
export const STATUS_BLOCKED = 'blocked' as const
export const STATUS_PAY_WAITING = 'pay_waiting' as const
export const STATUS_RETURN = 'return' as const
export const STATUS_DISTRIBUTED = 'distributed' as const
